import React from 'react';
import { Modal, List, Typography } from 'antd';
import { useSelector } from 'react-redux';

export default function CountriesListModal({ visible = false, onClose = () => {}, countryCodes = [] }) {
  const countriesState = useSelector(state => state.countries);
  const countriesByCode = countriesState?.value || {};

  const items = (countryCodes || []).map(code => {
    const c = Object.values(countriesByCode).find(x => String(x.c_code) === String(code)) || null;
    console.log(code, c);
    return { code, name: c ? c.c_short_name_eng : String(code) };
  });

  return (
    <Modal open={visible} onOk={onClose} onCancel={onClose} title={`Countries (${items.length})`} width={600}>
      <List
        dataSource={items}
        renderItem={item => (
          <List.Item>
            <Typography.Text strong style={{ marginRight: 12 }}>{item.code}</Typography.Text>
            <Typography.Text>{item.name}</Typography.Text>
          </List.Item>
        )}
      />
    </Modal>
  );
}
